export class DateUtil {

  private static monthList: string[] = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct.', 'Nov', 'Dec']

  public static trimToDay(date: Date): Date {
    return new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()));
  }

  public static trimToHour(date: Date): Date {
    return new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours()));
  }

  public static incDays(date: Date, days: number): Date {
    return new Date(date.getTime() + days * 1000 * 60 * 60 *24);
  }

  public static formatDate(date: Date): string {
    const yyyy = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    let monthStr = ''+month;
    let dayStr = ''+day;

    if (day < 10) dayStr = '0' + dayStr;
    if (month < 10) monthStr = '0' + monthStr;

    return dayStr + '/' + monthStr + '/' + yyyy;
  }

  public static formatDateTime(date: Date): string {
    const year = date.getFullYear();
    const month = date.getMonth();
    const day = date.getDate();
    const hours = date.getHours();
    const mins = date.getMinutes();

    let monthStr = this.monthList[month];

    let dayStr = ''+day;
    if (day < 10) dayStr = '0' + dayStr;

    let hourStr = ''+hours;
    if (hours < 10) hourStr = '0' + hourStr;

    let minsStr = ''+mins;
    if (mins < 10) minsStr = '0' + minsStr;

    return dayStr + ' ' + monthStr + ' ' + year + ' ' + hourStr + ':' + minsStr;
  }
}




